import { render, staticRenderFns } from "./ProyectoAssignarEmpleados.vue?vue&type=template&id=b8de93de&scoped=true&"
import script from "./ProyectoAssignarEmpleados.vue?vue&type=script&lang=js&"
export * from "./ProyectoAssignarEmpleados.vue?vue&type=script&lang=js&"
import style0 from "./ProyectoAssignarEmpleados.vue?vue&type=style&index=0&id=b8de93de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8de93de",
  null
  
)

export default component.exports